// extracted by mini-css-extract-plugin
module.exports = {"backlink__container":"BackLink_backlink__container__i9JCG","backlink__link":"BackLink_backlink__link__VNkYb","backlink__icon":"BackLink_backlink__icon__SyW8a"};